import React from "react";
import { getStyle } from "../../../styles/styles";
import { getBNFeeStructureMin, saveBNFeeStructureDetails } from "../../../networking/NetworkingFeeStructure";
import { getLookUpTable } from "../../../networking/Networking";
import AlertBox from "../../shared/AlertBox";
import DynamicSelect from "../../shared/DynamicSelect";
import { formatValidSelect } from "../../../helpers/FormatHelper";
import DynamicSearchSelect from "../../shared/DynamicSearchSelect";
import NumberInput from "../../shared/NumberInput";
import { searchCurrencies } from "../../../networking/NetworkingCurrencies";
import { validate } from "../../../helpers/ValidateHelper";

const style = getStyle();
export default class BNFeeStructureDetailForm extends React.Component {
    state = {
        feeStructureDetailList: [],
        deliveryMethodList: [],
        buySellList: [],
        currencyList: [],
        percentFlatList: [],
        feeSelectValue:'',
        feeSelectName:'',
        deliveryMethodValue:'',
        deliveryMethodName:'',
        currencyValue:'',
        currencyName:'',
        feeStructureDetailId: '',
        buySell: '',
        percentage:'',
        lowerTier:'',
        upperTier:'',
        minimumFee:'',
        maximumFee:'',
        percentFlatValue:'',
        percentFlatName:'',
        updateToken:'',
        showAlert: false,
        showAlertError: false,
        alertTitle: '',
        alertMessage: '',
        notFirstLoad:false,
        errors:[],
        validations: {
            feeSelectValue: true,
            currencyValue: true,
            deliveryMethodValue: true,
            percentFlatValue: true,
            buySell: true
        },
        disableFeeSelect: false
    }

    componentDidMount(){
        getBNFeeStructureMin().then(
            (value) => {
                var feesStructureMin = this.transformFeeStructureDetailList(value.feeStructures);
                var helper = [];
                for(var i=0;i<feesStructureMin.length;i++){
                    feesStructureMin[i].value = feesStructureMin[i]['FeeStructureID'];
                    feesStructureMin[i].name = feesStructureMin[i]['Description'];
                    helper.push(feesStructureMin[i]);
                }
                this.setState({feeStructureDetailList: helper},()=>{
                    if(this.props.selectedFeeStructureDetail.FeeStructureID !== undefined){
                        var FeeStructureDetail = this.props.selectedFeeStructureDetail;
                        this.setState({disableFeeSelect: true, feeSelectValue:FeeStructureDetail.FeeStructureID},()=>this.props.feeSelectValue(FeeStructureDetail.FeeStructureID))
                    }
                });
            }
        );
        getLookUpTable('Charge Types').then(
            (json) => {
                var lookUpTableDetails = json.lookUpTables[0].lookUpTableDetails;
                var helper = [];
                for(var i=0; i<lookUpTableDetails.length; i++){
                    lookUpTableDetails[i].value = lookUpTableDetails[i].LookUpTableDetail
                    lookUpTableDetails[i].name = lookUpTableDetails[i].LookUpTableDetail
                    helper.push(lookUpTableDetails[i]);
                }
                this.setState({percentFlatList: helper});
            }
        ); 
        getLookUpTable('Payment Delivery Method').then(
            (json) => {
                var lookUpTableDetails = json.lookUpTables[0].lookUpTableDetails;
                var helper = [];
                for(var i=0; i<lookUpTableDetails.length; i++){
                    lookUpTableDetails[i].value = lookUpTableDetails[i].LookUpTableDetail
                    lookUpTableDetails[i].name = lookUpTableDetails[i].LookUpTableDetail
                    helper.push(lookUpTableDetails[i]);
                }
                helper.splice(1, 0, {value:'ANY', name:'ANY'});
                this.setState({deliveryMethodList: helper});
            }
        ); 
        getLookUpTable('Type of transacction').then(
            (json) => {
                var lookUpTableDetails = json.lookUpTables[0].lookUpTableDetails;
                var helper = [];
                for(var i=0; i<lookUpTableDetails.length; i++){
                    lookUpTableDetails[i].value = lookUpTableDetails[i].LookUpTableDetail
                    lookUpTableDetails[i].name = lookUpTableDetails[i].LookUpTableDetail
                    helper.push(lookUpTableDetails[i]);
                }
                this.setState({buySellList: helper});
            }
        )
    }

    componentDidUpdate(prevProps){
        if(this.props.selectedFeeStructureDetail !== {} && prevProps.selectedFeeStructureDetail !== this.props.selectedFeeStructureDetail){
            var FeeStructureDetail = this.props.selectedFeeStructureDetail;
            var feeStructureDetailId = 0;
            var disableFeeSelect = false;
            if(FeeStructureDetail.FeeStructureDetailId !== null){
                feeStructureDetailId = FeeStructureDetail['FeeStructureDetailId'];
                disableFeeSelect = true;
            }

            if(FeeStructureDetail['CurrencyID'] !== null)
            {
                this.search(FeeStructureDetail['CurrencyID']);
            }
            this.setState({
                feeStructureDetailId : feeStructureDetailId,
                feeSelectValue: FeeStructureDetail['FeeStructureID'],
                buySell: FeeStructureDetail['BuySell'],
                deliveryMethodValue: FeeStructureDetail['DeliveryMethod'],
                percentFlatValue: FeeStructureDetail['PercentFlat'],
                percentage: FeeStructureDetail['Percentage'],
                lowerTier: FeeStructureDetail['LowerTier'],
                upperTier: FeeStructureDetail['UpperTier'],
                minimumFee: FeeStructureDetail['Minimum'],
                maximumFee: FeeStructureDetail['Maximum'],
                currencyValue: FeeStructureDetail['CurrencyID'],
                updateToken: FeeStructureDetail['UpdateToken'],
                disableFeeSelect: disableFeeSelect
            });
        }

        if(this.props.clearForm !== {} && this.props.clearForm === true){
            this.setState({
                feeStructureDetailId:'',
                feeSelectValue:'',
                BuySell:'',
                deliveryMethodValue:'',
                currencyValue:'',
                percentage:'',
                lowerTier:'',
                upperTier:'',
                minimumFee:'',
                maximumFee:'',
                percentFlatValue:'',
                updateToken:''           
            },()=>this.props.outClearForm(false));
        }
    }
    
    transformFeeStructureDetailList(list){
        var helper = [];
        for(var i = 0; i<list.length; i++){
            helper.push({'FeeStructureID': list[i]['FeeStructureID'],
            'Description': list[i]['Description']});
        }
        return helper;
    }
    
    search(query){
        searchCurrencies(query, 'active').then(
            (json) => {
                var helper = [];       
                helper.push({value:'ANY', name:'ANY'});
                if(query !== ''){
                    if(json!==undefined){
                        var cName = "";
                        for(var i=0; i<json.length; i++){     
                            if(i===0){
                                cName = json[i].CurrencyIDName;
                            }                       
                            helper.push({value: json[i].CurrencyID, name: json[i].CurrencyIDName})
                        }
                        if(json.length>1){
                            this.setState({currencyList: helper});
                        }else{
                            this.setState({validations: {...this.state.validations, currencyValue: true},currencyList: helper, currencyName: cName });
                        }
                    }else{
                        this.setState({currencyList: helper});
                    }   
                }
            }
        )
    }
    
    getFeeSelect(value){   
        if(value.value === undefined || value.value.toLowerCase().includes('select')){
            this.setState({feeSelectValue: ''});
            this.props.feeSelectValue(undefined);
        }
        else{
            this.setState({validations: {...this.state.validations, feeSelectValue: true},feeSelectValue: value.value});
            this.props.feeSelectValue(value.value);    
        }        
    }
    
    getDeliveryMethodSelect(value){
        if(value.value === undefined || value.value.toLowerCase().includes('select')){
            this.setState({deliveryMethodValue: ''});   
        }
        else{
            this.setState({validations: {...this.state.validations, deliveryMethodValue: true},deliveryMethodValue: value.value});        
        }
    }
    
    getCurrencySelect(value){    
        if(value.value === undefined || value.value.toLowerCase().includes('select')){
            this.setState({CurrencyValue: ''});        
        }
        else{
            this.setState({validations: {...this.state.validations, currencyValue: true},currencyValue: value.value});        
        }
    }
    
    getPercentFlatSelect(value){  
        if(value.value === undefined || value.value.toLowerCase().includes('select')){
            this.setState({percentFlatValue: ''});        
        }
        else{
            this.setState({validations: {...this.state.validations, percentFlatValue: true},percentFlatValue: value.value});        
        }
    }

    getBuySellSelect(value){ 
        if(value.value === undefined || value.value.toLowerCase().includes('select')){
            this.setState({buySell: ''});        
        }
        else{
            this.setState({validations: {...this.state.validations, buySell: true},buySell: value.value});        
        }
    }
    
    handleClearClick = (event) => {
        event.preventDefault();
        this.setState({
            //feeStructureDetailId:'',
            //feeSelectValue:'',
            deliveryMethodValue:'',
            deliveryMethodName:'',
            currencyValue:'',
            currencyName:'',
            percentage:'',
            lowerTier:'',
            upperTier:'',
            minimumFee:'',
            maximumFee:'',
            percentFlatValue:'',
            buySell:'',
            updateToken:'',
            validations: {
                feeSelectValue: true,
                currencyValue: true,
                deliveryMethodValue: true,
                percentFlatValue: true,
                buySell: true
            },
            disableFeeSelect: false    
        },()=>{
            this.props.feeSelectValue('')
            this.props.isClearDetail(true);
            });
    }

    handleSaveClick(event){
        event.preventDefault();
        let UserID = localStorage.getItem('UserID');
        var feeStructureDetailId=this.state.feeStructureDetailId;
        if(feeStructureDetailId ==''){
            feeStructureDetailId = 0;
        }
        
        var objectFilter = {
            FeeStructureDetailId: feeStructureDetailId,
            FeeStructureID: this.state.feeSelectValue,
            BuySell:this.state.buySell,
            CurrencyID:this.state.currencyValue,
            DeliveryMethod: this.state.deliveryMethodValue,
            PercentFlat: this.state.percentFlatValue,
            Percentage: this.state.percentage,
            LowerTier:this.state.lowerTier,
            UpperTier:this.state.upperTier,
            Minimum:this.state.minimumFee,
            Maximum:this.state.maximumFee,
            UpdateToken:this.state.updateToken,            
            userID: UserID
        }

        if(this.validateRequiredInputs()){
            if(this.validateMaxMin()){
                saveBNFeeStructureDetails(objectFilter).then(
                    (json)=> {
                        if (json.status !== 200){
                            this.setState({showAlert: true, alertMessage: 'An error occurred while trying to save the Fee Structure Details. Please try again.', alertTitle: 'Error'});
                        } else {
                            this.setState({
                                feeStructureDetailId:'',
                                buySell:'',
                                deliveryMethodValue:'',
                                currencyValue:'',
                                currencyName:'',
                                percentage:'',
                                lowerTier:'',
                                upperTier:'',
                                minimumFee:'',
                                maximumFee:'',
                                percentFlatValue:'',
                                updateToken:'',
                                showAlert: true, alertTitle: 'Fee Structure Detail Successfully saved.'});
                            this.props.updateFeeStructureDetailsTable(this.state.feeSelectValue);
                        }
                    }
                )
            }
        }
    }
    
        //Inputs Validations
    validateRequiredInputs(){
        const fields = [
            {displayName:'Fee', validateName: 'feeSelectValue', value:this.state.feeSelectValue, type: 'string'},
            {displayName:'Currency', validateName: 'currencyValue', value:this.state.currencyValue, type: 'string'},
            {displayName:'BuySell', validateName: 'buySell', value: this.state.buySell, type: 'string'},
            {displayName:'Delivery Method', validateName: 'deliveryMethodValue', value: this.state.deliveryMethodValue, type: 'string'},
            {displayName:'Percent / Flat', validateName: 'percentFlatValue', value:this.state.percentFlatValue, type: 'string'}
        ]
    
        const [valid, validations, errors] = validate(fields);
    
        this.setState({validations: {...this.state.validations, ...validations}});
    
        if (!valid) {
            this.setState({
                showAlertError: true, alertTitle: 'Error', alertMessage: 'Please fill all mandatory fields:', errors
            });
        }
    
        return valid;
    }
    
    validateMaxMin(){
        var maxFee=this.state.maximumFee;
        var minFee=this.state.minimumFee;
        var maxTier=this.state.upperTier;
        var minTier=this.state.lowerTier;
        if(maxFee===''){maxFee=0}
        if(minFee===''){minFee=0}
        if(maxTier===''){maxTier=0}
        if(minTier===''){minTier=0}        
        if(maxTier<minTier){
            this.setState({showAlert: true, alertTitle: 'Error', alertMessage: "Lower Tier can't be higher than Upper Tier."});
            return false;
        }
        if(maxFee<minFee){
            this.setState({showAlert: true, alertTitle: 'Error', alertMessage: "Minimum fee can't be higher than maximum fee."});
            return false;
        }
        return true;
    }
    
    closeAlert(){
        this.setState({showAlert: false, alertTitle: ''});
    }

    closeAlert2(){
        this.setState({showAlertError: false, alertTitle: ''});
    }
    handleUpdatePercentage(event){
        this.setState({percentage: event.target.value});
    }

    handleUpdateLowerTier(event){
        this.setState({lowerTier: event.target.value});
    }

    handleUpdateUpperTier(event){
        this.setState({upperTier: event.target.value});
    }
    
    handleUpdateMinimumFee(event){
        this.setState({minimumFee: event.target.value});
    }

    handleUpdateMaximumFee(event){
        this.setState({maximumFee: event.target.value});
    }

    render(){
        return(
            <div>
                <form className="uk-form-stacked uk-grid">
                    <div className="uk-width-1-2 uk-form-stacked">
                        <div className="uk-margin" style={{marginBottom: 10}}>
                            <label className="uk-form-label" htmlFor="form-fee-structure-detail-fee" style={style.boldLabel}>Fee (*)</label>
                            <div className="uk-form-controls">
                                <DynamicSelect className={formatValidSelect(this.state.validations.feeSelectValue)} id="form-fee-structure-detail-fee" getValue={this.getFeeSelect.bind(this)} placeholder="Select a Fee Structure..." data={this.state.feeStructureDetailList} 
                                objValue={{value: this.state.feeSelectValue, name: this.state.feeSelectName}} disabled={this.state.disableFeeSelect}/>  
                            </div>
                        </div>
                    </div>
                    <div className="uk-width-1-2 uk-form-stacked">
                        <div className="uk-margin" style={{marginBottom: 10}}>
                            <label className="uk-form-label" htmlFor="form-fee-structure-detail-buysell" style={style.boldLabel}>Buy/Sell (*)</label>
                            <div className="uk-form-controls">
                                <DynamicSelect className={formatValidSelect(this.state.validations.buySell)} id="form-fee-structure-detail-buysell" getValue={this.getBuySellSelect.bind(this)} data={this.state.buySellList}
                                objValue={{value: this.state.buySell, name: this.state.buySell}}/>
                            </div>
                        </div>
                    </div>
                    <div className="uk-width-1-2 uk-form-stacked" >
                        <div className="uk-margin" style={{marginBottom: 10}}>
                            <label className="uk-form-label" htmlFor="form-fee-structure-detail-deliverymethod" style={style.boldLabel}>Delivery Method (*)</label>
                            <div className="uk-form-controls">                                    
                                <DynamicSelect className={formatValidSelect(this.state.validations.deliveryMethodValue)} id="form-fee-structure-detail-deliverymethod" getValue={this.getDeliveryMethodSelect.bind(this)} data={this.state.deliveryMethodList}
                                objValue={{value: this.state.deliveryMethodValue, name: this.state.deliveryMethodName}}/>
                            </div>
                        </div>
                    </div>
                    <div className="uk-width-1-2 uk-form-stacked" >
                        <div className="uk-margin" style={{marginBottom: 10}}>
                            <label className="uk-form-label" htmlFor="form-fee-structure-detail-currency" style={style.boldLabel}>Currency (*)</label>
                            <div className="uk-form-controls">                               
                                <DynamicSearchSelect className={formatValidSelect(this.state.validations.currencyValue)} id="form-fee-structure-detail-currency" objValue={{value: this.state.currencyValue,name: this.state.currencyName}} placeholder="Select a Currency..." searchFunction={this.search.bind(this)} data={this.state.currencyList} getValue={this.getCurrencySelect.bind(this)}/>
                            </div>
                        </div>
                    </div>
                    <div className="uk-width-1-2 uk-form-stacked" >
                        <div className="uk-margin" style={{marginBottom: 10}}>
                            <label className="uk-form-label" htmlFor="form-fee-structure-detail-percentage">Percentage</label>
                            <div className="uk-form-controls">                            
                                <NumberInput className="uk-input" id="form-fee-structure-detail-percentage" placeholder="0.00" type="Rate" scale={2} value={this.state.percentage} onChange={this.handleUpdatePercentage.bind(this)}/>
                            </div>
                        </div>
                    </div>       
                    <div className="uk-width-1-2 uk-form-stacked" >
                        <div className="uk-margin" style={{marginBottom: 10}}>
                            <label className="uk-form-label" htmlFor="form-fee-structure-detail-percentflat" style={style.boldLabel}>Percent / Flat (*)</label>
                            <div className="uk-form-controls">
                                <DynamicSelect className={formatValidSelect(this.state.validations.percentFlatValue)} id="form-fee-structure-detail-percentflat" getValue={this.getPercentFlatSelect.bind(this)} data={this.state.percentFlatList}
                                objValue={{value: this.state.percentFlatValue, name: this.state.percentFlatName}}/>                                
                            </div>
                        </div>
                    </div> 
                    <div className="uk-width-1-2 uk-form-stacked" >
                        <div className="uk-margin" style={{marginBottom: 10}}>
                            <label className="uk-form-label" htmlFor="form-fee-structure-detail-lowertier">Lower Tier</label>
                            <div className="uk-form-controls">
                                <NumberInput className="uk-input" id="form-fee-structure-detail-lowertier" placeholder="0" type="Integer" value={this.state.lowerTier} onChange={this.handleUpdateLowerTier.bind(this)}/>
                            </div>
                        </div>
                    </div> 
                    <div className="uk-width-1-2 uk-form-stacked" >
                        <div className="uk-margin" style={{marginBottom: 10}}>
                            <label className="uk-form-label" htmlFor="form-fee-structure-detail-uppertier">Upper Tier</label>
                            <div className="uk-form-controls">
                                <NumberInput className="uk-input" id="form-fee-structure-detail-uppertier" placeholder="0" type="Integer" value={this.state.upperTier} onChange={this.handleUpdateUpperTier.bind(this)}/>
                            </div>
                        </div>
                    </div> 
                    <div className="uk-width-1-2 uk-form-stacked" >
                        <div className="uk-margin" style={{marginBottom: 10}}>
                            <label className="uk-form-label" htmlFor="form-fee-structure-detail-minimumfee">Minimum Fee</label>
                            <div className="uk-form-controls">
                                <NumberInput className="uk-input" id="form-fee-structure-detail-minimumfee" placeholder="0" type="Integer" value={this.state.minimumFee} onChange={this.handleUpdateMinimumFee.bind(this)}/>
                            </div>
                        </div>
                    </div> 
                    <div className="uk-width-1-2 uk-form-stacked" >
                        <div className="uk-margin" style={{marginBottom: 10}}>
                            <label className="uk-form-label" htmlFor="form-fee-structure-detail-maximumfee">Maximum Fee</label>
                            <div className="uk-form-controls">
                                <NumberInput className="uk-input" id="form-fee-structure-detail-maximumfee" placeholder="0" type="Integer" value={this.state.maximumFee} onChange={this.handleUpdateMaximumFee.bind(this)}/>
                            </div>
                        </div>
                    </div>   
                    <div className="uk-width-1-2 uk-form-stacked"></div>
                    <div className="uk-width-2-2 uk-margin">
                        <button className="uk-button uk-button-green" onClick={this.handleClearClick.bind(this)}>Clear Fields</button>
                        <button className="uk-button uk-button-green" onClick={this.handleSaveClick.bind(this)}>Save</button>
                        <hr/>
                    </div>
                    <AlertBox open={this.state.showAlert} onClose={this.closeAlert.bind(this)} title={this.state.alertTitle} message={this.state.alertMessage} type="Ok" okClick={this.closeAlert.bind(this)}/>
                    <AlertBox open={this.state.showAlertError} onClose={this.closeAlert2.bind(this)} title={this.state.alertTitle} message={this.state.alertMessage} messageBoldList={this.state.errors} type="Ok" okClick={this.closeAlert2.bind(this)}/>
                </form>
            </div>
        )
    }
}